import {
  WhyUsContainer,
  WhyUsWrapper,
  WInfo,
  WReviews,
  WReviewsContainer,
  FirstReview,
  SecondReview,
  ThirdReview,
} from "./why-us.styles"
import whyUs1 from "../../assets/icons/why-us-1.svg"
import whyUs2 from "../../assets/icons/why-us-2.svg"
import whyUs3 from "../../assets/icons/why-us-3.svg"
import whyUs4 from "../../assets/icons/why-us-4.svg"
import whyUs5 from "../../assets/icons/why-us-5.svg"
import pointer from "../../assets/icons/pointer.svg"
import firstReview from "../../assets/img/firstReview.jpg"
import secondReview from "../../assets/img/secondReview.jpg"
import thirdReview from "../../assets/img/thirdReview.jpg"
import reviewsBg from "../../assets/img/reviews-bg.png"
import Button from "../button/button.component"
// import { Link } from "rou"

import "./styles.scss"

const WhyUs = ({ props }) => {
  const renderButtonText = () => {
    return (
      <div>
        <img src={pointer} alt="" style={{ width: 15, marginRight: 10 }} />
        {props[6]}
      </div>
    )
  }
  return (
    <WhyUsWrapper>
      <WhyUsContainer id="why-us">
        <WInfo>
          <ul>
            <li>
              <h2>{props[1]}</h2>
            </li>
            <li>
              <span className="img">
                <img src={whyUs1} alt="" />
              </span>
              <span className="text">{props[2]}</span>
            </li>
            <li>
              <span className="img">
                <img src={whyUs2} alt="" />
              </span>
              <span className="text">{props[9]}</span>
            </li>
            <li>
              <span className="img">
                <img src={whyUs3} alt="" />
              </span>
              <span className="text">{props[10]}</span>
            </li>
            <li>
              <span className="img">
                <img src={whyUs4} alt="" />
              </span>
              <span className="text">{props[11]}</span>
            </li>
            <li>
              <span className="img">
                <img src={whyUs5} alt="" />
              </span>
              <span className="text">{props[12]}</span>
            </li>
            <li className="maps-to-service">
              <a
                to="https://maps.app.goo.gl/r6SVKsCPjRwEsQXm9"
                href={"https://maps.app.goo.gl/r6SVKsCPjRwEsQXm9"}
                target="_blank"
                rel="noreferrer noopener"
                // spy={true}
                // smooth={true}
                // offset={0}
                // duration={500}
                style={{ width: "100%" }}
              >
                <Button children={renderButtonText()} />
              </a>
            </li>
          </ul>
        </WInfo>
        <WReviews>
          <img src={reviewsBg} alt="" className="reviews-bg" />
          <WReviewsContainer>
            <h2>{props[7]}</h2>
            <FirstReview>
              {/* <img className="logo" src={logo} alt="" /> */}
              <img className="firstReview" src={firstReview} alt="" />
            </FirstReview>

            <SecondReview>
              <img src={secondReview} alt="" />
            </SecondReview>

            <ThirdReview>
              <img className="thirdReview" src={thirdReview} alt="" />
              <a
                href={
                  "https://www.google.com/maps/place/%D0%9B%D0%B0%D0%B1%D0%BE%D1%80%D0%B0%D1%82%D0%BE%D1%80%D0%B8%D1%8F+%D0%B0%D0%B2%D1%82%D0%BE%D1%8D%D0%BB%D0%B5%D0%BA%D1%82%D1%80%D0%BE%D0%BD%D0%B8%D0%BA%D0%B8/@46.9738207,28.8304084,17.5z/data=!4m8!3m7!1s0x40c97ed1e30ae9fb:0x25b598e15dac60fc!8m2!3d46.9736801!4d28.8310961!9m1!1b1!16s%2Fg%2F11g6_0jl3v?authuser=0&entry=ttu&g_ep=EgoyMDI1MDIyNS4wIKXMDSoASAFQAw%3D%3D"
                }
                target="_blank"
                rel="noreferrer"
              >
                <button>
                  {props[8]}
                  {/* <img src={externalLink} alt="" /> */}
                </button>
              </a>
            </ThirdReview>
          </WReviewsContainer>
        </WReviews>
      </WhyUsContainer>
    </WhyUsWrapper>
  )
}

export default WhyUs
